<template>
    <div class="container">
        <Progress :stage="1"/>
        <div class="section-paragraph">{{getLabel('INFORMATION_GUIDE3')}}</div>
        <a-form @submit="handleSubmit" :form="form" class="information-form">
            <a-row>
                <a-col :span="12">
                    <a-form-item
                        :label="getLabel('INFORMATION_LEFT1_LABEL')"
                        :labelCol="{ span: 7 }"
                        :wrapperCol="{ span: 15 }"
                    >
                        <a-input
                            size="large"
                            :tabindex="0"
                            :placeholder="getLabel('INFORMATION_LEFT1_TIP')"
                            v-decorator="['family_name', {rules: [{ required: true, message: getLabel('INFORMATION_LEFT1_TIP') }]}]" autocomplete="off"/>
                    </a-form-item>
                    <a-form-item
                        :label="getLabel('INFORMATION_RIGHT1_LABEL')"
                        :labelCol="{ span: 7 }"
                        :wrapperCol="{ span: 15 }"
                    >
                        <a-input
                            size="large"
                            :tabindex="1"
                            :placeholder="getLabel('INFORMATION_RIGHT1_TIP')"
                            v-decorator="['first_name', {rules: [{ required: true, message:  getLabel('INFORMATION_RIGHT1_TIP') }]}]" autocomplete="off"/>
                    </a-form-item>
                    <a-form-item
                        :label="getLabel('INFORMATION_LEFT2_LABEL')"
                        :labelCol="{ span: 7 }"
                        :wrapperCol="{ span: 15 }"
                    >
                        <a-select
                            size="large"
                            :placeholder="getLabel('INFORMATION_LEFT2_TIP')"
                            v-decorator="['gender', {rules: [{ required: true, message: getLabel('INFORMATION_LEFT2_TIP') }]}]">
                            <a-select-option :value="1">{{getLabel('INFORMATION_LEFT2_OPTION1')}}</a-select-option>
                            <a-select-option :value="2">{{getLabel('INFORMATION_LEFT2_OPTION2')}}</a-select-option>
                            <a-select-option :value="3">{{getLabel('INFORMATION_LEFT2_OPTION3')}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item
                        :label="getLabel('INFORMATION_RIGHT3_LABEL')"
                        :labelCol="{ span: 7 }"
                        :wrapperCol="{ span: 15 }"
                    >
                        <a-input
                            size="large"
                            :placeholder="getLabel('INFORMATION_RIGHT3_TIP')"
                            v-decorator="['identity_number', {rules: [{ required: true, message: getLabel('INFORMATION_RIGHT3_TIP') }]}]" autocomplete="off"/>
                    </a-form-item>
                    <a-form-item
                        :label="getLabel('INFORMATION_RIGHT2_LABEL')"
                        :labelCol="{ span: 7 }"
                        :wrapperCol="{ span: 15 }"
                    >
                        <a-select
                            showSearch
                            optionFilterProp="children"
                            size="large"
                            :placeholder="getLabel('INFORMATION_RIGHT2_TIP')"
                            v-decorator="['location', {rules: [{ required: true, message:  getLabel('INFORMATION_RIGHT2_TIP')}]}]">
                            <a-select-option v-for="(item,index) in getCountryList()" :key="'country'+index" :value="item.code">
                                {{item[language]}}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item
                        :label="getLabel('INFORMATION_LEFT3_LABEL')"
                        :labelCol="{ span: 7 }"
                        :wrapperCol="{ span: 15 }"
                    >
                        <a-locale-provider :locale="language === 'zh' ? zhCN : en_US">
                            <a-date-picker
                                size="large"
                                :placeholder="getLabel('INFORMATION_BIRTHDAY_TIP')"
                                :defaultPickerValue="moment('1970-01-01', 'YYYY-MM-DD')"
                                v-decorator="['birthday', {rules: [{ required: true, message: getLabel('INFORMATION_BIRTHDAY_TIP') }]}]" style="width: 100%"/>
                        </a-locale-provider>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item
                        :label="getLabel('INFORMATION_LEFT4_LABEL')"
                        :labelCol="{ span: 7 }"
                        :wrapperCol="{ span: 15 }"
                    >
                        <a-input
                            size="large"
                            :placeholder="getLabel('INFORMATION_LEFT4_TIP')"
                            v-decorator="['company', {rules: [{ required: true, message: getLabel('INFORMATION_LEFT4_TIP') }]}]" autocomplete="off"/>
                    </a-form-item>
                    <a-form-item
                        :label="getLabel('INFORMATION_RIGHT4_LABEL')"
                        :labelCol="{ span: 7 }"
                        :wrapperCol="{ span: 15 }"
                    >
                        <a-input
                            size="large"
                            :placeholder="getLabel('INFORMATION_RIGHT4_TIP')"
                            v-decorator="['post', {rules: [{ required: true, message: getLabel('INFORMATION_RIGHT4_TIP') }]}]" autocomplete="off"/>
                    </a-form-item>
                    <a-form-item
                        :label="getLabel('INFORMATION_LEFT5_LABEL')"
                        :labelCol="{ span: 7 }"
                        :wrapperCol="{ span: 15 }"
                    >
                        <a-input
                            size="large"
                            :placeholder="getLabel('INFORMATION_LEFT5_TIP')"
                            v-decorator="['phone_number', {rules: [{ required: true, message:  getLabel('INFORMATION_LEFT5_TIP') }]}]" autocomplete="off"/>
                    </a-form-item>
                    <a-form-item
                        :label="getLabel('INFORMATION_RIGHT5_LABEL')"
                        :labelCol="{ span: 7 }"
                        :wrapperCol="{ span: 15 }"
                    >
                        <a-input
                            size="large"
                            :placeholder="getLabel('INFORMATION_RIGHT5_TIP')"
                            v-decorator="['address', {}]" autocomplete="off"/>
                    </a-form-item>
                    <a-form-item
                        :label="getLabel('INFORMATION_LEFT6_LABEL')"
                        :labelCol="{ span: 7 }"
                        :wrapperCol="{ span: 15 }"
                    >
                        <a-input
                            size="large"
                            :placeholder="getLabel('INFORMATION_LEFT6_TIP')"
                            v-decorator="['assistant_name', {}]" autocomplete="off"/>
                    </a-form-item>
                    <a-form-item
                        :label="getLabel('INFORMATION_RIGHT6_LABEL')"
                        :labelCol="{ span: 7 }"
                        :wrapperCol="{ span: 15 }"
                    >
                        <a-input
                            size="large"
                            :placeholder="getLabel('INFORMATION_RIGHT6_TIP')"
                            v-decorator="['assistant_email', {rules: [{ type: 'email', message: getLabel('INFORMATION_RIGHT6_TIP') }]}]"
                            autocomplete="off"/>
                    </a-form-item>
                    <a-form-item
                        :label="getLabel('INFORMATION_LEFT7_LABEL')"
                        :labelCol="{ span: 7 }"
                        :wrapperCol="{ span: 15 }"
                    >
                        <a-input
                            size="large"
                            :placeholder="getLabel('INFORMATION_LEFT7_TIP')"
                            v-decorator="['assistant_phone_number', {}]" autocomplete="off"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <div class="btn-group">
                <a-button type='default' size="large" @click="backToSummary" v-if="isSecondEnter">{{getLabel('TIP_CANCEL')}}</a-button>
                <a-button type="primary" htmlType='submit' size="large" style="width: 130px;">{{getLabel('BUTTON_NEXT')}}</a-button>
            </div>
        </a-form>
    </div>
</template>

<script>
	import {mapState} from 'vuex';
	import Progress from '../components/Progress';
	import Language from '../util/language';
	import getCountries from '../util/Countries';
	import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
	import en_US from 'ant-design-vue/lib/locale-provider/en_US';
	import {washData} from "../util/tools";
	import moment from 'moment';
    import Controller from '../components/Controller';

	export default {
		components: {
			Progress
        },
        mixins: [Controller],
		data () {
			return {
				form: this.$form.createForm(this),
				zhCN,
				en_US,
				moment
			}
		},
        mounted() {
			let currentUser = JSON.parse(JSON.stringify(this.currentUser));
			let birthday = currentUser.birthday;
            if (birthday) {
				currentUser.birthday = moment(birthday, 'YYYY-MM-DD');
            }
	        this.form.setFieldsValue(currentUser);
        },
		computed: {
			...mapState({
				language: state => state.main.language,
				currentUser: state => state.main.currentUser,
				isSecondEnter: state => state.main.isSecondEnter
			})
		},
		methods: {
			// 获取描述
			getLabel: function (key) {
				return Language(this.language, key);
			},
            // 获取国家
            getCountryList: function () {
				return getCountries(this.language);
            },
            // 提交
			handleSubmit: function (e) {
				e.preventDefault();
				this.form.validateFields((err, values) => {
					if (!err) {
						let _formData = washData(values);
						if (_formData.birthday) {
							_formData.birthday = _formData.birthday.format('YYYY-MM-DD');
                        }
						this.$store.dispatch('information/submitInformation', {
						    values:  _formData,
                            cb: this.nextPage
                        });
					}
				})
			},
			backToSummary: function () {
				this.$store.commit('main/backToSummary');
			}
		}
	};
</script>

<style lang="less" scoped>
    .information-form {
        margin-top: 30px;
    }
</style>
